export default __webpack_public_path__ + "static/media/albert-einstein-logo.35b6d5d3.png";